var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedIn"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29367",
    "data-name": "Rectangle 29367",
    width: 22,
    height: 22,
    transform: "translate(661 1080)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_704",
    "data-name": "Mask Group 704",
    transform: "translate(-661 -1080)",
    clipPath: "url(#linkedIn)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-11T145903.307",
    "data-name": "svgexport-6 - 2022-05-11T145903.307",
    transform: "translate(661 1080)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    width: 22,
    height: 22,
    rx: 3,
    fill: "#afaeb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12111",
    "data-name": "Path 12111",
    d: "M7.925,6A1.875,1.875,0,1,1,6.05,4.125,1.875,1.875,0,0,1,7.925,6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12112",
    "data-name": "Path 12112",
    d: "M7.5,9.125v8.284a.464.464,0,0,1-.464.466H5.06a.464.464,0,0,1-.465-.465V9.125A.465.465,0,0,1,5.06,8.66H7.036a.465.465,0,0,1,.464.465Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12113",
    "data-name": "Path 12113",
    d: "M17.83,13.438v4.01a.426.426,0,0,1-.427.427H15.278a.426.426,0,0,1-.427-.427V13.561c0-.58.17-2.54-1.516-2.54-1.306,0-1.573,1.341-1.625,1.944v4.483a.428.428,0,0,1-.421.428H9.235a.426.426,0,0,1-.426-.427V9.089a.426.426,0,0,1,.426-.427h2.052a.427.427,0,0,1,.427.427v.723a2.91,2.91,0,0,1,2.738-1.289c3.4,0,3.377,3.172,3.377,4.915Z",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.9f3fcbe544eb005baf216dee5b364211.svg";
export { ForwardRef as ReactComponent };